<template>
  <div class="examlist">
    <Header />
    <Nav />
    <div class="pages">
      <div class="examlist-menu">
        宏云课堂
        <img src="../assets/icon/right-gray.svg" alt="">
        考试入口
      </div>
      <div class="examlist-container">
        <div class="examlist-item">
          <div class="examlist-item-header">国有企业招标采购训练营</div>
          <div class="examlist-item-content">
            <div class="examlist-item-class">
              <dl>
                <dt><img src="../assets/examlist/class1.png" alt=""></dt>
                <dd>
                  第一学期
                  <span>（未学习）</span>
                </dd>
              </dl>
              <dl>
                <dt><img src="../assets/examlist/class2.png" alt=""></dt>
                <dd>
                  第二学期
                  <span>（未学习）</span>
                </dd>
              </dl>
              <dl>
                <dt><img src="../assets/examlist/class3.png" alt=""></dt>
                <dd>
                  第三学期
                  <span>（未学习）</span>
                </dd>
              </dl>
              <dl>
                <dt><img src="../assets/examlist/class4.png" alt=""></dt>
                <dd>
                  第四学期
                  <span>（未学习）</span>
                </dd>
              </dl>
            </div>
            <div class="examlist-item-btn" @click="noshow">去考试</div>
          </div>
        </div>
        <div class="examlist-item">
          <div class="examlist-item-header">政府采购训练营</div>
          <div class="examlist-item-content">
            <div class="examlist-item-class">
              <dl>
                <dt><img src="../assets/examlist/class5.png" alt=""></dt>
                <dd>
                  第一学期
                  <span>（未学习）</span>
                </dd>
              </dl>
              <dl>
                <dt><img src="../assets/examlist/class6.png" alt=""></dt>
                <dd>
                  第二学期
                  <span>（未学习）</span>
                </dd>
              </dl>
            </div>
            <div class="examlist-item-btn" @click="noshow">去考试</div>
          </div>
        </div>
        <div class="examlist-item">
          <div class="examlist-item-header">采购案例解析</div>
          <div class="examlist-item-content">
            <div class="examlist-item-class">
              <dl>
                <dt><img src="../assets/examlist/class7.png" alt=""></dt>
                <dd>
                  第一学期
                  <span class="finish">（已学习）</span>
                </dd>
              </dl>
            </div>
            <div class="examlist-item-btn active" @click="goHref('/exam')">去考试</div>
          </div>
        </div>
        <div class="examlist-item">
          <div class="examlist-item-header">施工标评审实务</div>
          <div class="examlist-item-content">
            <div class="examlist-item-class">
              <dl>
                <dt><img src="../assets/examlist/class8.png" alt=""></dt>
                <dd>
                  第一学期
                  <span>（未学习）</span>
                </dd>
              </dl>
            </div>
            <div class="examlist-item-btn" @click="noshow">去考试</div>
          </div>
        </div>
      </div>
    </div>
    <div class="examlist-noclick" v-if="boxflag">
      <div class="examlist-noclick-content">
        <div class="examlist-noclick-close">
          <img src="../assets/examlist/close.svg" alt="" @click="close">
        </div>
        <p>请学习完所有课程后进行考试</p>
        <div class="examlist-noclick-btn" @click="close">知道了</div>
      </div>
    </div>
    <Fixed/>
    <Footer />
  </div>
</template>

<script>
import menuList from "@/assets/data/typeLeave.js";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Nav from "@/components/Nav.vue";
import Fixed from '@/components/Fixed.vue';
export default {
  name: "Classlist",
  components: {
    Header,
    Nav,
    Footer,
    Fixed,
  },
  data() {
    return {
      menuList,
      boxflag: false
    };
  },
  methods: {
    goHref(url) {
      this.$router.push(url);
    },
    close() {
      this.boxflag = false
    },
    noshow() {
      this.boxflag = true
    }
  },
};
</script>

<style lang="less" scoped>
.examlist {
  &-menu {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
    padding-top: 40px;
    padding-bottom: 20px;
    img {
      margin-left: 4px;
      margin-right: 4px;
    }
  }
  &-container {
    width: 1324px;
    margin: 0 auto;
  }
  &-item {
    width: 1324px;
    height: 364px;
    background: url(../assets/examlist/bg.png) no-repeat;
    background-size: 100% 100%;
    &-header {
      width: 1300px;
      margin: 0 auto;
      height: 61px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #3e414d;
      line-height: 61px;
      background: url(../assets/examlist/header.png) no-repeat;
      background-size: 100% 100%;
      text-indent: 24px;
      border-bottom: 1px solid #eeeeee;
    }
    &-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 42px;
    }
    &-class {
      padding-left: 44px;
      dl {
        width: 246px;
        height: 192px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #eeeeee;
        display: inline-block;
        margin-right: 12px;
        dt {
          img {
            display: block;
            width: 246px;
            height: 142px;
          }
        }
        dd {
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #595959;
          line-height: 52px;
          text-align: center;
          span {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 52px;
            &.finish {
              color: #ff7e20;
            }
          }
        }
      }
    }
    &-btn {
      width: 104px;
      height: 32px;
      background: linear-gradient(90deg, #bbafac 0%, #a19796 100%);
      box-shadow: 0px 5px 5px 0px rgba(0, 0, 2, 0.12);
      border-radius: 2px;
      border: 1px solid #b6acab;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 32px;
      text-shadow: 0px 5px 5px rgba(0, 0, 2, 0.12);
      text-align: center;
      margin-right: 70px;
      cursor: pointer;
      &.active {
        background: linear-gradient(90deg, #fd441f 0%, #e1251b 100%);
        box-shadow: 0px 5px 5px 0px rgba(182, 20, 26, 0.22);
        border-radius: 2px;
        border: 1px solid #e1251b;
      }
    }
  }
  &-noclick {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    &-content {
      width: 400px;
      height: 161px;
      background: url(../assets/examlist/bg.png) no-repeat;
      background-size: 100% 100%;
      border-radius: 8px;
      box-sizing: border-box;
      padding: 0 5px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    &-close {
      text-align: right;
      padding-top: 5px;
      padding-right: 8px;
      img {
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }
    p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.74);
      line-height: 24px;
      margin-top: 20px;
      text-align: center;
    }
    &-btn {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #0052d9;
      line-height: 56px;
      border-top: 1px solid #e7e7e7;
      margin-top: 27px;
      text-align: center;
      cursor: pointer;
    }
  }
}
.mr14 {
  margin-right: 14px !important;
}
.pt0 {
  padding-top: 0 !important;
}
.pb20 {
  padding-bottom: 20px;
}
</style>